import React from 'react'
import { Box } from '@chakra-ui/react'
import { keyframes } from '@emotion/react'

const pulseKeyframe = keyframes`
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
`

interface LoadingDotsProps {
    color?: string
    size?: string
    speed?: number
}

export default function LoadingDots({
    color = 'gray.200',
    size = '12px',
    speed = 1,
}: LoadingDotsProps) {
    const animation = `${pulseKeyframe} ${speed}s infinite ease-in-out`

    return (
        <Box display="flex" justifyContent="center" alignItems="center">
            {[0, 1, 2].map(index => (
                <Box
                    key={index}
                    bg={color}
                    width={size}
                    height={size}
                    borderRadius="50%"
                    mx="2px"
                    animation={animation}
                    style={{ animationDelay: `${(index * speed) / 3}s` }}
                />
            ))}
        </Box>
    )
}
